var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { query, state } from 'lit/decorators.js';
import { html, css, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { customElement, PICInputOptions, PICContext, PIC, PICSuggestion, PICSelector, PICAction } from '../../Internals';
import { computePosition, platform, size, flip, offset } from '@floating-ui/dom';
import { offsetParent } from 'composed-offset-position';
let PICMenu = class PICMenu extends PICInputOptions {
    set curSelected(iNum) {
        var _a;
        if (iNum >= this.parentInputOptions.length)
            this.curSelected_ = ((_a = this.parentInputOptions) === null || _a === void 0 ? void 0 : _a.length) - 1;
        else if (iNum < 0)
            this.curSelected_ = 0;
        else
            this.curSelected_ = iNum;
        this.requestUpdate();
    }
    get curSelected() {
        return this.curSelected_;
    }
    /** For use when cmd-updating options */
    clearSelection() {
        this.curSelected_ = -1;
        this.requestUpdate();
    }
    set parent(iParent) {
        if (iParent instanceof PICSelector) {
            iParent.menu = this;
            this.mode = 'selector';
        }
        else if (iParent instanceof PICSuggestion) {
            iParent.menu = this;
            this.mode = 'suggestion';
        }
        else if (iParent instanceof PICContext) {
            iParent.menu = this;
            this.mode = 'context';
        }
        this.parent_ = iParent;
    }
    get parent() {
        return this.parent_;
    }
    set parentInputOptions(opt) {
        this.pIO = opt;
        this.requestUpdate();
    }
    get parentInputOptions() {
        return this.pIO;
    }
    set isHidden(hidden) {
        var _a;
        this.hide_ = hidden;
        if (hidden) {
            if (((_a = PIC.getInstance.events.activePicker) === null || _a === void 0 ? void 0 : _a.picker) == this)
                PIC.getInstance.events.activePicker = undefined;
        }
        else {
            PIC.getInstance.events.activePicker = { pickerMode: 'ignoreLocalScroll', picker: this };
        }
        if (this.mode == 'selector') {
            if (this.parent && this.parent.selectedOption) {
                this.curSelected = this.parent.options.indexOf(this.parent.selectedOption);
                this.scrollTo_ = this.curSelected !== 0;
            }
            this.requestUpdate();
        }
    }
    get isHidden() { return this.hide_; }
    ;
    constructor() {
        super();
        this.pIO = [];
        this.hide_ = true;
        this.curSelected_ = 0;
        this.searchStr = '';
        this.renderDown = true;
        this.scrollTo_ = false;
        this.scrollToTop = false;
        this.inMobileModal = false;
        this.shouldHide = true;
        this.rows = 1;
        this.isinput__ = false;
    }
    hide() {
        var _a;
        if (this.shouldHide) {
            this.hide_ = true;
            if (this.parent instanceof PICSelector)
                this.parent.requestUpdate();
            if (((_a = PIC.getInstance.events.activePicker) === null || _a === void 0 ? void 0 : _a.picker) == this)
                PIC.getInstance.events.activePicker = undefined;
            this.requestUpdate();
        }
        else {
            this.shouldHide = true;
        }
    }
    connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        this.inMobileModal = /*PIC.getInstance.isMobileOrTablet &&*/ ((_b = ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.getRootNode()).firstElementChild) === null || _b === void 0 ? void 0 : _b.nodeName) == 'PIC-MODAL';
        PIC.getInstance.events.addMenu(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        PIC.getInstance.events.removeMenu(this);
    }
    static get styles() {
        const defaultStyle = css `
            :host {
                position: absolute;
                width: -webkit-fill-available;
                display: block;
                box-sizing: unset;
                margin: 0;
                --pic-maxRows: 1;
                --pic-menuItemHeight: 36px;
                --rows-shown: 0;
            }
            .picmenu {
                box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                z-index: 10;
                min-width: 154px;
                background-color: var(--pic-surfaceColor);
                outline: none;
                overflow-y: auto;
                overflow-x: hidden;
                cursor: pointer;
                max-height: var(--m-h, calc((var(--pic-menuItemHeight, 36px) + 16px) * var(--pic-maxRows, 10)));
                min-height: calc((var(--pic-menuItemHeight, 20px) + 16px) * var(--rows-shown));
            }
            .picmenuitem {
                padding: 6px;
                display: flex;
                flex-direction: column;
                align-content: flex-start;
                justify-content: center;
                height: var(--pic-menuItemHeight, 36px);
            }
            .picmenuitem:hover {
                background-color: var(--pic-primaryHoverColor);
            }
            .picmenuitem:focus, .picmenuitem.focus {
                background-color: var(--pic-primaryFocusColor);
                outline: none;
            }
            .picmenuitem:active {
                background-color: var(--pic-primaryActiveColor);
                outline: none;
            }
            .picmenu.touchscreen {
                overflow-x: auto;
            }
            .optval {
                white-space: nowrap;
            }
            .optvalsub{
                white-space: nowrap;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    markFirst() {
        this.curSelected = 0;
        this.scrollTo_ = true;
        this.scrollToTop = true;
    }
    markLast() {
        var _a;
        if (((_a = this.parentInputOptions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.curSelected = this.parentInputOptions.length - 1;
            this.scrollTo_ = true;
            this.scrollToTop = false;
        }
    }
    markNext(jump) {
        if (jump)
            this.curSelected += jump;
        else
            this.curSelected++;
        this.scrollTo_ = true;
        this.scrollToTop = false;
    }
    markPrevious(jump) {
        if (jump)
            this.curSelected -= jump;
        else
            this.curSelected--;
        this.scrollTo_ = true;
        this.scrollToTop = true;
    }
    jumpTo(jump) {
        this.curSelected = jump;
        this.scrollTo_ = true;
        this.scrollToTop = true;
    }
    selectMarked() {
        return this.parentInputOptions[this.curSelected];
    }
    changeTimer(inpVal) {
        this.typeTimeout ? clearTimeout(this.typeTimeout) : '';
        this.typeTimeout = setTimeout(() => {
            this.searchStr = '';
            this.typeTimeout = undefined;
        }, 1000);
        this.searchStr += inpVal;
        this.curSelected = this.parent.optionContainer.searchValInOptionsIndex(this.searchStr, this.curSelected);
        if (!this.renderDown)
            this.curSelected = ((this.curSelected - this.parentInputOptions.length) * -1) - 1;
        this.requestUpdate();
    }
    updateParent(event, value) {
        if (this.parent_ instanceof PICSelector) {
            this.parent_.selectedOption = value;
            this.parent_.changeHandler(event);
            this.parent_.requestUpdate();
            this.parent_.focus();
        }
        else if (this.parent_ instanceof PICSuggestion) {
            this.parent_.preventBlur = true;
            this.parent_._selectOption({ option: value, eventRef: event });
            this.parent_.requestUpdate();
        }
        this.isHidden = true;
    }
    clickHandler(e, idx, iOpt) {
        this.curSelected = idx;
        if (iOpt.action) {
            let act = new PICAction();
            act.actionOptions = iOpt.action;
            act.triggerEvent(e);
        }
        this.updateParent(e, iOpt);
    }
    calcPos() {
        var _a, _b;
        let refElm = (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.container');
        let thisRef = this;
        if (refElm && this)
            computePosition(refElm, this, {
                platform: Object.assign(Object.assign({}, platform), { getOffsetParent: (element) => platform.getOffsetParent(element, offsetParent) }),
                strategy: 'fixed',
                middleware: [
                    offset(4),
                    size({
                        apply({ availableHeight }) {
                            thisRef.style.setProperty('--m-h', `${Math.max(150, (availableHeight - 30))}px`);
                        }
                    }),
                    flip({
                        mainAxis: true,
                        crossAxis: false,
                        fallbackStrategy: 'initialPlacement'
                    }),
                ]
            }).then(({ x, y, placement }) => {
                // this.style.setProperty('top', y + 'px');
            });
    }
    setHasEllipsis() {
        var _a, _b;
        this.hasEllipsis = ((_a = this.optCont) === null || _a === void 0 ? void 0 : _a.offsetWidth) < ((_b = this.optCont) === null || _b === void 0 ? void 0 : _b.scrollWidth);
    }
    willUpdate(_changedProperties) {
        super.willUpdate(_changedProperties);
        this.setHasEllipsis();
    }
    updated() {
        if (!this.isHidden)
            if (this.selectedElement && this.scrollTo_) {
                //TODO fix align to bottom when marking next
                this.optCont.scrollTop = this.selectedElement.offsetTop;
                this.scrollTo_ = false;
            }
        this.style.setProperty('--pic-maxRows', this.rows + '');
        this.calcPos();
        this.style.setProperty('--rows-shown', this.pIO.length < 10 ? this.pIO.length + '' : '10');
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        let height = '48px';
        if (this.parent && (this.parent instanceof PICSelector || this.parent instanceof PICSuggestion)) {
            switch (this.parent.density) {
                case 'inline':
                    height = '20px';
                    break;
                case 'high':
                    height = '20px';
                    break;
                case 'medium':
                    height = '30px';
                    break;
                case 'low':
                    height = '36px';
                    break;
            }
            this.style.setProperty('--pic-menuItemHeight', height);
            // this.style.setProperty('z-index', '3');
            this.style.setProperty('top', '36px !important');
        }
    }
    isMenuDirectionDown() {
        var _a;
        let isDown = true;
        let parentRect = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        let menuItemHeightString = window.getComputedStyle(this).getPropertyValue(`--pic-menuItemHeight`);
        let menuItemHeight;
        if (menuItemHeightString)
            menuItemHeight = parseInt(menuItemHeightString) + 16;
        else
            menuItemHeight = 48;
        if (parentRect) {
            let countUp, countDown;
            countDown = (window.innerHeight - (parentRect.y + parentRect.height)) / menuItemHeight;
            if (countDown > 10) {
                countDown = 10;
            }
            countUp = (parentRect.y / menuItemHeight);
            if (countUp > 10) {
                countUp = 10;
            }
            //prefer rendering down;
            if (this.parentInputOptions.length < countDown && this.parentInputOptions.length < countUp)
                countUp = -1;
            if (countDown >= countUp) {
                isDown = true;
            }
            else {
                isDown = false;
            }
        }
        return isDown;
    }
    getContainerStyle() {
        var _a, _b;
        let width = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.clientWidth;
        let styles = [];
        styles.push({ 'max-width': '100%' });
        styles.push({ 'position': 'fixed' });
        styles.push({ 'overflow-y': 'auto' });
        styles.push({ 'overflow-x': 'hidden' });
        styles.push({ 'width': width + 'px' });
        if (this.parent instanceof PICSelector) {
            let container = (_b = this.parent.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.container');
            styles.push({ 'left': container.getBoundingClientRect().left + 'px' });
            if (this.isMenuDirectionDown()) {
                styles.push({ 'bottom': 'unset' });
                styles.push({ 'top': container.getBoundingClientRect().bottom + 'px' });
            }
            else {
                styles.push({ 'top': 'unset' });
                styles.push({ 'bottom': window.innerHeight - container.getBoundingClientRect().top + 'px' });
            }
        }
        this.hide_ ? styles.push({ 'display': 'none' }) : '';
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getItemClass(idx) {
        let dens = this.parent.density;
        return {
            'picmenuitem': true,
            'focus': idx == this.curSelected,
            ['' + dens]: true,
        };
    }
    getContainerClass(/*iIsDown: boolean, */ iRenderBig) {
        let dens = this.parent.density;
        let touchscreen = navigator.maxTouchPoints > 1;
        return {
            'inner-input': true,
            'picmenu': true,
            'pic-body2': true,
            'touchscreen': touchscreen,
            ['' + dens]: true,
            'context': this.mode === 'context',
            'compact': this.mode !== 'context' && !iRenderBig
        };
    }
    getValSubClass() {
        return {
            'pic-caption': true,
            'optvalsub': true
        };
    }
    renderListItem(opt, idx) {
        var _a;
        return html `<div 
            class=${classMap(this.getItemClass(idx))} 
            data-key=${opt.key} 
            data-val=${opt.val} 
            data-valsub=${ifDefined(opt.valsub)}
            @click=${(e) => this.clickHandler(e, idx, opt)}>
                <div class="optval"><strong>${this.mode == 'selector' ? opt.val : opt.valDisp}</strong></div>
                ${opt.valsub ? html `<div class=${classMap(this.getValSubClass())}>${this.mode == 'selector' ? opt.valsub : opt.valsubDisp}</div>` : ''}
            ${this.hasEllipsis ? html `<pic-tooltip>${(_a = opt.valsub) !== null && _a !== void 0 ? _a : opt.val}</pic-tooltip>` : ''}
        </div>`;
    }
    renderContext() {
        return html `${this.parent.contextOpts.map((cont, idx) => { this.parent.renderContextItem(cont, idx); })}`;
    }
    renderList( /*iIsDown: boolean*/) {
        var _a;
        /*if (iIsDown !== this.renderDown){
            this.parentInputOptions.reverse();
            this.renderDown = iIsDown;
        }*/
        return html `${(_a = this.parentInputOptions) === null || _a === void 0 ? void 0 : _a.map((opt, idx) => this.renderListItem(opt, idx))}`;
    }
    focusParent() {
        var _a;
        (_a = this.parent) === null || _a === void 0 ? void 0 : _a.focus();
    }
    render() {
        let renderBig = true;
        if (this.parent instanceof PICSelector || this.parent instanceof PICSuggestion)
            renderBig = this.parent.activeGroupHasValSub;
        this.calcPos();
        //this.isMenuDirectionDown()
        return html `
        ${this.parent instanceof PICSelector ? html ` 
            <style> :host { position: relative !important;}
        </style>
        ` : nothing}
        ${this.renderCSS(true)}
        <div 
            style=${styleMap(this.getContainerStyle())} 
            class=${classMap(this.getContainerClass(/*isDown, */ renderBig))}
            @focus=${this.focusParent}
            >
            ${this.mode == 'context' ? this.renderContext() : this.renderList( /*isDown*/)}
        </div>
        `;
    }
};
PICMenu.closed = true;
__decorate([
    state()
], PICMenu.prototype, "mode", void 0);
__decorate([
    query('.picmenuitem.focus')
], PICMenu.prototype, "selectedElement", void 0);
__decorate([
    query('.picmenu')
], PICMenu.prototype, "optCont", void 0);
PICMenu = __decorate([
    customElement('pic-menu')
], PICMenu);
export { PICMenu };
//# sourceMappingURL=PICMenu.js.map